<template>
	<div class="icon" :class="iconClassName(iconName, iconSize)"></div>
</template>

<script lang="ts" setup>
import { iconClassName } from "@/utils/iconClassName";

type Props = {
	iconName: string;
	iconSize?: number;
};

const { iconName, iconSize = 72 } = defineProps<Props>();
</script>

<style lang="scss" scoped></style>
